import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Carousel({
  children,
  containerClass,
  previousOnClick,
  nextOnClick,
  previousBtnClass,
  nextBtnClass,
}) {
  return (
    <div>
      <div
        className={classNames(
          'flex items-center justify-between w-full overflow-hidden',
          containerClass,
        )}
      >
        <button
          className={classNames(
            'z-[1] w-[5%] border-0 p-0 text-center transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:no-underline hover:opacity-90 hover:outline-none motion-reduce:transition-none',
            previousBtnClass,
          )}
          onClick={previousOnClick}
        >
          <span className="inline-block">
            <FontAwesomeIcon
              icon={['fal', 'chevron-left']}
              className="h-5 w-5 mt-1.5"
            />
          </span>
        </button>
        {children}
        <button
          className={classNames(
            'z-[1] w-[5%] border-0 p-0 text-center transition-opacity duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1.0)] hover:no-underline hover:opacity-90 hover:outline-none motion-reduce:transition-none',
            nextBtnClass,
          )}
          type="button"
          onClick={nextOnClick}
        >
          <span className="inline-block">
            <FontAwesomeIcon
              icon={['fal', 'chevron-right']}
              className="h-5 w-5 mt-1.5"
            />
          </span>
        </button>
      </div>
    </div>
  );
}
